// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Opinions_wrapper__Xh16M","title":"Opinions_title__6UTCT","mainImage":"Opinions_mainImage__5krpS","slider":"Opinions_slider__uuBv_"};